<template>
  <a @click="$emit('click', $event)" :href="href"
     v-bind="$attrs"
     class="big-button"
    :class="{'icon-btn':icon, 'loading':loading, 'disabled':(disabled || loading)}" >
    <template v-if="loading">
      <v-spinner></v-spinner>
    </template>

	  <div class="layout-row">
		  <inline-svg class="icon" v-if="icon" :src="icon" />
		  <div class="layout-column">
		  <template v-if="label">
      <span class="label">
        {{ label }}
      </span>
		  <span class="desc">
        {{ desc }}
      </span>
			  </template>
			  <template v-else>
				  <slot></slot>
			  </template>
		  </div>
		  <div v-if="hasArrow" class="arrow-container">
			  <svg fill="none" viewBox="0 0 15 15" height="24" width="24" xmlns="http://www.w3.org/2000/svg" class="arrow">
				  <path xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" d="M12.0581 4.55812L12.9419 5.44187L7.50001 10.8837L2.05814 5.44187L2.94189 4.55812L7.50001 9.11625L12.0581 4.55812Z" fill="#C5C7D2"></path>
			  </svg>

<!--			  <inline-svg class="arrow" :src="require('@/assets/img/arrow-bottom.svg')" />-->
		  </div>
	  </div>



  </a>
</template>

<script>

import VSpinner from "@/components/base/v-spinner";
export default {
  components: {VSpinner},
  inheritAttrs: false,
  name: "BigButton",

  data: function (){
      return {
      }
  },
  // model: {
  //   prop: 'v-model',
  //   event: 'change'
  // },

  props: {
    icon: {
      default: null,
    },
	  hasArrow: {
		  default: false,
		  type: Boolean,
	  },
	  disabled: {
		  default: false,
		  type: Boolean,
	  },
    loading: {
      default: false,
      type: Boolean,
    },
    href: {
      default: null,
      type: String,
    },
    label: {
      default: "",
	    type: String,
    },
	  desc: {
		  default: "",
		  type: String,
	  },
  },
  methods: {
  },
  computed: {
    hasError() {
        return !!this.error && this.wasActive;
    }
  }
};
</script>
<style lang="scss" scoped>
.big-button {
	padding: 20px;
	background: $light-blue;
	border-radius: 16px;
	transition: 0.2s background ease-in-out;

	&:hover {
		background: #EEF4FF;
	}
	.icon {
		margin-right: 16px;
		//width: 64px;
	}
	.label {
		font-weight: bold;
		font-size: 18px;
		color: $black;
		margin-bottom: 6px;
	}
	.desc {
		font-weight: normal;
		font-size: 14px;
		color: #747B8B;
		margin-top: 5px;
		line-height: 20px;
	}
	.arrow-container {
		display: flex;
		align-items: center;
		padding: 10px;
		svg {
			transform: rotate(-90deg);
		}
	}
  &.loading {
    .label {
      opacity: 0;
    }
  }

}
</style>
